export default __webpack_public_path__ + "static/media/u.c2b13605.svg";